// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cookieControl__ControlButton{bottom:86px!important}@media (min-width:1024px){.cookieControl__ControlButton{bottom:20px!important}}", ""]);
// Exports
module.exports = exports;
